import { IconButton, RoundedButton } from '../../button';
import { useCallback, useEffect, useState } from 'react';
import { 
  ModalWrapper,
  ModalBox,
  CloseButtonWrapper,
  ModalActionsContainer,
  ModalActionsWrapper,
  ModalContentWrapper
} from './Modals.styled';
import {
  IconWrapper,
  Title,
  Message
} from './ConfirmationModal.styled';
import { Icon } from '../../icon';

const ConfirmationModal = ({ isOpen, isExtended, icon, onClose, onConfirm, title, message, displayCancel=true, onConfirmLabel='Continue', cancelLabel='Cancel', onCancel, extraActions, dataTestId, showIcon = true, iconWidth = "24px",}) => {
  
  const [ open, setOpen ] = useState(isOpen);

  const onHandleClose = useCallback(() => {
    setOpen(false);
    onClose && onClose();
  }, [onClose]);

  const onHandleCancel = useCallback(() => {
    setOpen(false);
    onCancel && onCancel();
  }, [onCancel]);

  const onHandleConfirm = useCallback(() => {
    setOpen(false);
    onConfirm && onConfirm();
  }, [onConfirm]);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <ModalWrapper data-testid={dataTestId} $isOpen={open}>
      <ModalBox isExtended={isExtended} height="305px">
        <CloseButtonWrapper>
          <IconButton icon="close" width="16px" height="16px" onClick={onHandleCancel} />
        </CloseButtonWrapper>
        <ModalContentWrapper>
          {showIcon && icon && (
            <IconWrapper isExtended={isExtended}>
              <Icon name={icon} width={iconWidth} height="24px" />
            </IconWrapper>
          )}
          <Title isExtended={isExtended}>{title}</Title>
          <Message>{message}</Message>
        </ModalContentWrapper>
        <ModalActionsContainer>
          <ModalActionsWrapper isExtended={isExtended}>
            {displayCancel && (
              <RoundedButton outline={true} onClick={onHandleClose}>
                {cancelLabel}
              </RoundedButton>
            )}
            <RoundedButton onClick={onHandleConfirm} kind={"blue"}>
              {onConfirmLabel}
            </RoundedButton>
            {extraActions && extraActions.map((action) => (
              <RoundedButton
                onClick={action.onClick}
                color={action.textColor}
              >
                {action.label}
              </RoundedButton>
            ))}
          </ModalActionsWrapper>
        </ModalActionsContainer>
      </ModalBox>
    </ModalWrapper>
  );
};

export default ConfirmationModal;
